import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Traductor from 'components/Traductor';
import Modal from 'components/batches/Details/DetailsModal';
import BrandFilter from 'components/vehicleFilters/BrandFilter';
import ListFilter from 'components/vehicleFilters/ListFilter';

import { filterBrands, filterModels } from 'constants/Filters';

const FiltersModal = ({ filters, showFilters, dispatch, filtersOptions }) => {
    const t = useMemo(() => new Traductor(), []);
    return (
        <Modal visible={showFilters}>
            <div className="u-p c-vehicle-filters">
                <div className="u-pb">
                    <p className="u-h4 c-modal__title u-text-center">
                        {t.getTraduction('Filters')}
                        <button
                            className="c-modal__close-btn  js-modal-close u-float-right"
                            type="button"
                            aria-label="Close filters modal icon"
                            onClick={() => dispatch({ type: 'SHOW_FILTERS' })}
                        />
                    </p>
                </div>
                <BrandFilter
                    filterTitle={t.getTraduction('Brands')}
                    itemList={filtersOptions.Brands}
                    filterName={filterBrands}
                    filters={filters}
                    selectFilter={(name, data) => {
                        dispatch({
                            type: 'UPDATE_FILTERS',
                            payload: { name, data },
                        });
                    }}
                    showImages={true}
                    isMultiSelect={true}
                />
                {!!filters[filterBrands]?.length && (
                    <ListFilter
                        filterTitle={t.getTraduction('Modelos')}
                        itemList={filtersOptions.Models}
                        filterName={filterModels}
                        filters={filters}
                        selectFilter={(name, data) =>
                            dispatch({
                                type: 'UPDATE_FILTERS',
                                payload: { name, data },
                            })
                        }
                        showImages={true}
                        isMultiSelect={true}
                    />
                )}
            </div>
        </Modal>
    );
};

FiltersModal.propTypes = {
    showFilters: PropTypes.bool.isRequired,
    filters: PropTypes.shape({}).isRequired,
    filtersOptions: PropTypes.shape({
        Brands: PropTypes.arrayOf(
            PropTypes.shape({
                Description: PropTypes.string,
                Id: PropTypes.string,
                Models: PropTypes.arrayOf(
                    PropTypes.shape({
                        Id: PropTypes.number,
                        Description: PropTypes.string,
                    })
                ),
            })
        ),
        Models: PropTypes.arrayOf(
            PropTypes.shape({
                Id: PropTypes.number,
                Description: PropTypes.string,
            })
        ),
    }).isRequired,
    dispatch: PropTypes.func.isRequired,
};

export default FiltersModal;
